import env from '../../../env/env';

export const TRIVIA_GOLDEN_BALL = `${env.REACT_APP_STATIC_BASE_URL}marketplace/img/commons/trivia/winner.png`;
